import { render, staticRenderFns } from "./MainCandidates.vue?vue&type=template&id=8ec67822&"
import script from "./MainCandidates.vue?vue&type=script&lang=js&"
export * from "./MainCandidates.vue?vue&type=script&lang=js&"
import style0 from "./MainCandidates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports